var Video = function(options){
  var self = this;

  var defaults = {
    videoContainer: '.video',
    playPauseButton: '.video__play-pause-button',
    buttonPausedClass: 'video__play-pause-button--paused'
  };

  // var settings = {...defaults, ...options}
  var settings = $.extend({}, defaults, options);
  var videos = {};

  var init = function() {
    document.querySelectorAll(settings.videoContainer).forEach(function(i, e){
      if($(e).find('video').length){
        videos[i] = {
          video: $('video', e).get(0),
          playPauseButton: $(settings.playPauseButton, e).get(0)
        };
        videos[i].pause = function() {
          videos[i].video.pause();
          $(videos[i].playPauseButton).addClass(settings.buttonPausedClass);
        };
        videos[i].play = function() {
          videos[i].video.play();
          $(videos[i].playPauseButton).removeClass(settings.buttonPausedClass);
        };
        $(videos[i].playPauseButton).on('click', function(e){
          e.preventDefault();
          videos[i].video.paused ? videos[i].play() : videos[i].pause();
        });
        videos[i].play();
      };
    });
  }

  init();

  return videos;
}
